/**
 * Brand Workspace v2 routes (web.md §2.2). Every one of them names the workspace with `?ws=`: none is
 * workspace-agnostic (components/shell/accessRoutes.ts), so TenantProvider keeps `?ws` on them.
 */

/** The four Edit Brand Workspace pages, in side-menu order (spec:162-167). */
export const EDIT_PAGE_KEYS = ['brand', 'assets', 'workflow', 'danger'] as const;
export type EditPageKey = (typeof EDIT_PAGE_KEYS)[number];

export const WORKSPACE_CREATE_PATH = '/workspace/new';
export const WORKSPACE_EDIT_PATH = '/workspace/edit';
/** Brand Setup, the full-height wizard. */
export const WORKSPACE_SETUP_PATH = '/workspace/setup';

export function isEditPageKey(value: string | null | undefined): value is EditPageKey {
  return typeof value === 'string' && (EDIT_PAGE_KEYS as readonly string[]).includes(value);
}

const wsQuery = (slug: string | null | undefined) => (slug ? `?ws=${encodeURIComponent(slug)}` : '');

/** `/workspace/edit/<page>?ws=<slug>`; without a slug, TenantProvider adds the active one. */
export function editPagePath(page: EditPageKey, slug?: string | null): string {
  return `${WORKSPACE_EDIT_PATH}/${page}${wsQuery(slug)}`;
}

/** `/workspace/setup?ws=<slug>`: Brand Setup for that workspace. */
export function setupPath(slug: string): string {
  return `${WORKSPACE_SETUP_PATH}${wsQuery(slug)}`;
}
